import React from 'react';
import { Model } from '../../hooks/useModelState';
import { ISceneManagerContext } from '../../hooks/SceneManagerProvider/sceneManagerContext';
import { useSceneLegend } from './SceneLegendProvider';
import {
  generatePipeTypeLegend,
  generateStopeShapeLegend,
  generateCustomStopeShapeLegend
} from './legendUtils';

interface LegendSyncProps {
  model: Model;
  context: ISceneManagerContext;
}

const LegendSync = ({ model, context }: LegendSyncProps) => {
  const { setLegendData, setShowLegend } = useSceneLegend();
  const { showPipes } = model;
  // The stope-shape legend is irrelevant in the fill view, where stope shapes drive the fill render.
  const showStopeShapeLegend = model.showStopeShapes && context.state.currentScene?.key !== 'STOPE_FILL';

  const getStopeLegendData = React.useCallback(() => (
    model.stopeLegendConfig
      ? generateCustomStopeShapeLegend(model.stopeLegendConfig)
      : generateStopeShapeLegend()
  ), [model.stopeLegendConfig]);

  React.useEffect(() => {
    if (showPipes) {
      setLegendData(generatePipeTypeLegend(model, model.recipeState));
      setShowLegend(true);
    } else if (showStopeShapeLegend) {
      setLegendData(getStopeLegendData());
      setShowLegend(true);
    } else {
      setShowLegend(false);
      setLegendData(null);
    }
  }, [getStopeLegendData, showPipes, model.recipeState, showStopeShapeLegend, model.stopeLegendConfig]);

  return null;
};

export default LegendSync;
